const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { validateAndExecute } = require('./signaturePattern');

const {
  FETCH_DEPOSIT_RENOVATION_CANCELLATION_DATA_REQUEST,
  FETCH_DEPOSIT_RENOVATION_CANCELLATION_DATA_FAILURE,
  FETCH_DEPOSIT_RENOVATION_CANCELLATION_DATA_SUCCESS,

  DEPOSIT_RENOVATION_TO_CANCEL_SUCCESS,
  DEPOSIT_RENOVATION_TO_CANCEL_REQUEST,
  DEPOSIT_RENOVATION_TO_CANCEL_FAILURE,

  DEPOSIT_RENOVATION_CANCEL_SET_VISIBLE_STEP,
  DEPOSIT_RENOVATION_CANCEL_VALIDATE,
  DEPOSIT_RENOVATION_SHOW_CANCEL_MODAL,
} = require('constants/contactCenter/actionTypes');

// To Cancel
const depositRenovationToCancelRequest = () => ({
    type: DEPOSIT_RENOVATION_TO_CANCEL_REQUEST,
});

const depositRenovationToCancelSuccess = (payload) => ({
    type: DEPOSIT_RENOVATION_TO_CANCEL_SUCCESS,
    payload
});

const depositRenovationToCancelFailure = (payload) => ({
    type: DEPOSIT_RENOVATION_TO_CANCEL_FAILURE,
    payload
});

// Get Conditions
const depositRenovationConditionsRequest = () => ({
    type: FETCH_DEPOSIT_RENOVATION_CANCELLATION_DATA_REQUEST,
});

const depositRenovationConditionsSuccess = (payload) => ({
    type: FETCH_DEPOSIT_RENOVATION_CANCELLATION_DATA_SUCCESS,
    payload
});

const depositRenovationConditionsFailure = (payload) => ({
    type: FETCH_DEPOSIT_RENOVATION_CANCELLATION_DATA_FAILURE,
    payload
});

const setVisibleStep = step => ({
  type: DEPOSIT_RENOVATION_CANCEL_SET_VISIBLE_STEP,
  payload: {
      step
  }
});

const showCancelModal = (show) => ({
  type: DEPOSIT_RENOVATION_SHOW_CANCEL_MODAL,
  payload: {
      show
  }
});

const validateStep = step => ({
  type: DEPOSIT_RENOVATION_CANCEL_VALIDATE,
  payload: {
      step
  }
});

const fetchDepositRenovationToCancel = (depositCancellationData) => (dispatch) => {    
    dispatch(depositRenovationToCancelRequest())
    const requestData = {
        query: depositCancellationData,
      };
    
    return APIPost(dispatch, apiURLBuilder.getURL('requestContractDepositRenewalCancel'), requestData)
    .then(response =>
      {
        dispatch(
            depositRenovationToCancelSuccess(response)
        )
      }
    )
    .catch(response => dispatch(depositRenovationToCancelFailure({ error: response.error })));
}

const requestDepositRenovationToCancel = ({ originalDepositContract, originalDepositImpositions = [] }) => (dispatch, getState) => {
  validateAndExecute(dispatch, getState, (dispatch, getState, dataToken) => {
      dispatch(fetchDepositRenovationToCancel({
        originalDepositContract,
        originalDepositImpositions,
        dataToken
      }));
  });
}

const requestDepositRenovationConditions = (originalDepositContract) => (dispatch) => {
    dispatch(depositRenovationConditionsRequest());

    const requestData = {
      query: {
        originalDepositContract,
      },
    };
  
    return APIGet(dispatch, apiURLBuilder.getURL('requestContractDepositRenewal'), requestData)
      .then(response =>
        {
          dispatch(
            depositRenovationConditionsSuccess({ renovations: response, depositId: originalDepositContract })
          )
        }
      )
      .catch(response => dispatch(depositRenovationConditionsFailure({ error: response.error })));
}

module.exports = {
    requestDepositRenovationToCancel,
    requestDepositRenovationConditions,
    setVisibleStep,
    validateStep,
    showCancelModal
};
